import { ref, onMounted, resolveComponent, openBlock, createElementBlock, Fragment, renderList, normalizeClass, toDisplayString, createCommentVNode, withDirectives, createElementVNode, normalizeStyle, vModelDynamic, vModelSelect, vModelCheckbox, createVNode } from 'vue';
import Swal from 'sweetalert2';

var script = {
    name:"InputReactiveForm",
    props:{
        ListQuestions:{
            typeof:Array,
            value:function (){ return []; }
        },
        ClassInputs:{
            typeof:String,
            value:function (){ return ""; }
        },
        ClassContainer:{
            typeof:String,
            value:function (){ return ""; }
        },
        ShowPlasceholder:{
            typeof:Boolean,
            value:function (){ return false; }
        },
        ClassErrorsContainer:{
            typeof:String,
            value:function (){ return ""; }
        },
        ClassErrorsText:{
            typeof:String,
            value:function (){ return ""; }
        },
        documentsAllowed: {
            type: Array,
            default: function () { return []; }
        },
    },
    setup: function setup(props){
        var QuestionReactiveForm=ref([]);
        var classInputs=ref("");
        var classContainer=ref("");
        var showPlasceholder=ref(false);
        var classErrorsContainer=ref("");
        var classErrorsText=ref("");
        
        onMounted(function (){
            try{
                classInputs.value=props.ClassInputs;
                classContainer.value=props.ClassContainer;
                showPlasceholder.value=props.ShowPlasceholder;
                classErrorsContainer.value=props.ClassErrorsContainer;
                classErrorsText.value=props.ClassErrorsText;
                QuestionReactiveForm.value=(isEmptyQuestions())==true?props.ListQuestions:[];
            }
            catch(ex){
                console.log("Error in reactive form =>",ex);
            }
        });
        function getSelectedCheckbox(options, questionPosition){
            questionPosition.is_touched=true;
            var filteredOptions = options.filter(function (opt) { return opt.value; });
            setResponseToggleActive(questionPosition, filteredOptions);
        }
        function toggleActive(option, options, questionPosition){
            options.map(function (option) {
                option.isActive = false;
            });
            option.isActive = true;
            setResponseToggleActive(questionPosition, option.option);
        }
        function setResponseToggleActive(questionPosition, option){
            questionPosition.response = option;
            checkTextArea(QuestionReactiveForm.value);
        }
        function isEmptyQuestions(){
            return props.ListQuestions.length>0?true:false;
        }
        function setNewData(data){
            QuestionReactiveForm.value=data;
        }
        function selectStyle(strucValidation,data){
            if(strucValidation==0 && data!="")
            { return {'border':'2px solid blue !important'} }
            if(strucValidation>0 && data=="")
            { return {'border':'2px solid red !important'} } 
            if(strucValidation>0 && data.length>0)
            { return {'border':'2px solid red !important'} }                
        }
        function set_element_in_list(data){
            var _response_question= Object.values(QuestionReactiveForm.value);
            var isexist=is_exist_element_in_list(data);
            if(isexist == "no_existe"){
                _response_question.map(function (element){
                    if(data.show_value_in==element.order){
                        element.response.push(data.response);
                    }
                });
                data.response="";
            }else if(isexist == 'existe'){
                Swal.fire({
                        title: "Aviso",
                        text: "Esta elemento ya esta agregada a la lista, por favor seleccioné otra del listado.",
                        icon: "warning",
                        confirmButtonText: "OK",
                        confirmButtonColor: '#FEB72B'
                    });
            }
            QuestionReactiveForm.value=_response_question;
        }
        function is_exist_element_in_list(data){
            var question =search_question_of_type_textarea(data);
            if(question != undefined){
                if(question.response.length==0){
                    return "no_existe"
                }
                else {
                    var exist=question.response.find(function (element){
                        if(element==data.response){
                            return element;
                        }
                    });
                    if(exist==undefined || exist==null){
                        return 'no_existe'
                    }else {
                        return 'existe'
                    }
                }
            }
            return 'no_aplica'
        }
        function search_question_of_type_textarea(data){
            return QuestionReactiveForm.value.find(function (element){
                if(data.show_value_in==element.order){
                    return element;
                }
            });
        }

        function delete_element(element,position){
            element.splice(position,1);
        }
        
        function checkTextArea(data){
            data.map(function (event){
                if(event.question_relationship_id!=0){
                    data.find(function (elemnt){
                        if(event.question_relationship_id==elemnt.order){
                            event.showQuestion=event.depend_on_response==elemnt.response?true:false;
                            if(event.showQuestion==false){
                                if(event.question_type!="textarea"){
                                    event.response="";
                                }
                                if(event.question_type=="textarea"){
                                    event.response=[];
                                }
                                event.options.map(function (event){ return event.isActive=false; });
                            }
                        }
                    });
                }
            });
        }

        function loadDocument(event,isDrag,question){
            var ref;

            var file = [];
            if (isDrag)
                { file = event.dataTransfer.files; }
            else
                { file = event.target.files; }

            var fileAttributes = getDocumentAttributes(file);
            var isexceedTheMaximunSize = exceedTheMaximunSize(16777216,fileAttributes.size);
            if(isexceedTheMaximunSize){
                Swal.fire({
                    title: "Aviso",
                    html: "<p style=\"font-family:Roboto;font-size:15px;\">El peso del archivo sobrepasa \n                        el limite establecido de <span style=\"font-weight: 700;\"> 16 MB</span>\n                        </p>",
                    icon: "error",
                });  
            }else {
                (ref = question.response).push.apply(ref, file);
            }
        }

        function exceedTheMaximunSize(maxSize, size) {
            if (size > maxSize)
            { return true }
            return false
        }

         function getDocumentAttributes(document) {
            var attributes = {
            name: document[0].name,
            extension: document[0].type.split('/')[1],
            completeExtension: ("." + (document[0].type.split('/')[1])),
            size: document[0].size,
            };
            
            return attributes;
        }

        function getFile(selector) {
            document.getElementById(selector).value = "";
            document.getElementById(selector).click();
        }

        return {QuestionReactiveForm: QuestionReactiveForm,setNewData: setNewData,selectStyle: selectStyle,
         toggleActive: toggleActive, getSelectedCheckbox: getSelectedCheckbox,checkTextArea: checkTextArea,classInputs: classInputs,
         classContainer: classContainer,showPlasceholder: showPlasceholder,classErrorsContainer: classErrorsContainer,
         classErrorsText: classErrorsText,set_element_in_list: set_element_in_list,delete_element: delete_element,loadDocument: loadDocument,
         getFile: getFile}
    },
    watch:{
      "QuestionReactiveForm":{
        handler: function handler(data){
            this.$emit("return-data-form",data);
        },
        deep:true
      }
    }
};

var _hoisted_1 = { key: 0 };
var _hoisted_2 = ["for"];
var _hoisted_3 = ["id"];
var _hoisted_4 = ["type", "id", "name", "onUpdate:modelValue", "onBlur", "placeholder"];
var _hoisted_5 = ["id"];
var _hoisted_6 = ["for"];
var _hoisted_7 = ["id", "name", "onChange", "onUpdate:modelValue", "onBlur"];
var _hoisted_8 = ["value", "id"];
var _hoisted_9 = ["id"];
var _hoisted_10 = ["for"];
var _hoisted_11 = ["id", "name"];
var _hoisted_12 = ["onClick"];
var _hoisted_13 = { style: {"width":"90%"} };
var _hoisted_14 = /*#__PURE__*/createElementVNode("div", { style: {"width":"10%","text-align":"right"} }, [
  /*#__PURE__*/createElementVNode("strong", null, "X")
], -1 /* HOISTED */);
var _hoisted_15 = ["id"];
var _hoisted_16 = ["for"];
var _hoisted_17 = ["id", "name", "onClick"];
var _hoisted_18 = ["id"];
var _hoisted_19 = ["for"];
var _hoisted_20 = ["onUpdate:modelValue", "name", "value", "id", "onChange"];
var _hoisted_21 = ["for"];
var _hoisted_22 = ["id"];
var _hoisted_23 = ["for"];
var _hoisted_24 = ["id"];
var _hoisted_25 = ["for"];
var _hoisted_26 = ["onClick", "onChange"];
var _hoisted_27 = { id: "select-file" };
var _hoisted_28 = /*#__PURE__*/createElementVNode("button", { type: "button" }, " Seleccionar Archivo ", -1 /* HOISTED */);
var _hoisted_29 = { style: {"height":"0px","width":"0px","overflow":"hidden"} };
var _hoisted_30 = ["id", "accept", "onChange"];
var _hoisted_31 = ["onClick"];
var _hoisted_32 = { style: {"width":"90%"} };
var _hoisted_33 = /*#__PURE__*/createElementVNode("div", { style: {"width":"10%","text-align":"right"} }, [
  /*#__PURE__*/createElementVNode("strong", null, "X")
], -1 /* HOISTED */);

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_DatePicker = resolveComponent("DatePicker");

  return (openBlock(true), createElementBlock(Fragment, null, renderList($setup.QuestionReactiveForm, function (question, index) {
    return (openBlock(), createElementBlock("div", {
      class: normalizeClass($setup.classContainer),
      key: index
    }, [
      (question.showQuestion)
        ? (openBlock(), createElementBlock("div", _hoisted_1, [
            ($setup.showPlasceholder==false)
              ? (openBlock(), createElementBlock("label", {
                  key: 0,
                  for: question.testing_question_id+'_'+index
                }, toDisplayString(question.question), 9 /* TEXT, PROPS */, _hoisted_2))
              : createCommentVNode("v-if", true),
            (question.question_type=='text' || question.question_type=='number')
              ? (openBlock(), createElementBlock("div", {
                  key: 1,
                  id: 'content_text_and_number_'+index,
                  class: normalizeClass('content_text_and_number_'+index)
                }, [
                  withDirectives(createElementVNode("input", {
                    type: question.question_type,
                    id: question.testing_question_id+'_'+index,
                    name: question.testing_question_id+'_'+index,
                    class: normalizeClass($setup.classInputs),
                    "onUpdate:modelValue": function ($event) { return ((question.response) = $event); },
                    onBlur: function ($event) { return (question.is_touched=true); },
                    style: normalizeStyle($setup.selectStyle(question.errors.length,question.response)),
                    placeholder: $setup.showPlasceholder==true?question.question:null
                  }, null, 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_4), [
                    [vModelDynamic, question.response]
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_3))
              : createCommentVNode("v-if", true),
            (question.question_type=='select')
              ? (openBlock(), createElementBlock("div", {
                  key: 2,
                  id: 'content_select_'+index,
                  class: normalizeClass('content_select_'+index)
                }, [
                  ($setup.showPlasceholder==true)
                    ? (openBlock(), createElementBlock("label", {
                        key: 0,
                        for: question.testing_question_id+'_'+index
                      }, toDisplayString(question.question), 9 /* TEXT, PROPS */, _hoisted_6))
                    : createCommentVNode("v-if", true),
                  withDirectives(createElementVNode("select", {
                    id: question.testing_question_id+'_'+index,
                    name: question.testing_question_id+'_'+index,
                    onChange: function ($event) { return ($setup.set_element_in_list(question)); },
                    class: normalizeClass($setup.classInputs),
                    "onUpdate:modelValue": function ($event) { return ((question.response) = $event); },
                    onBlur: function ($event) { return (question.is_touched=true); },
                    style: normalizeStyle($setup.selectStyle(question.errors.length,question.response))
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(question.options, function (optionData, index3) {
                      return (openBlock(), createElementBlock("option", {
                        value: optionData.option,
                        key: index3,
                        id: optionData.option_id+'_'+index3
                      }, toDisplayString(optionData.name_option), 9 /* TEXT, PROPS */, _hoisted_8))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_7), [
                    [vModelSelect, question.response]
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_5))
              : createCommentVNode("v-if", true),
            (question.question_type=='textarea')
              ? (openBlock(), createElementBlock("div", {
                  key: 3,
                  id: 'content_textarea_'+index,
                  class: normalizeClass('content_textarea_'+index)
                }, [
                  ($setup.showPlasceholder==true)
                    ? (openBlock(), createElementBlock("label", {
                        key: 0,
                        for: question.testing_question_id+'_'+index
                      }, toDisplayString(question.question), 9 /* TEXT, PROPS */, _hoisted_10))
                    : createCommentVNode("v-if", true),
                  createElementVNode("div", {
                    id: question.testing_question_id+'_'+index,
                    name: question.testing_question_id+'_'+index,
                    class: normalizeClass($setup.classInputs)
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(question.response, function (listResponse, index4) {
                      return (openBlock(), createElementBlock("div", { key: index4 }, [
                        createElementVNode("div", {
                          style: normalizeStyle([{"color":"white","display":"flex","width":"100%","cursor":"pointer","margin-top":"10px","margin-bottom":"10px","padding-left":"10px","padding-right":"10px","padding-top":"10px","padding-bottom":"10px"}, [(index4%2==0)?{'background': 'rgba(212, 143, 146, 0.5)'}:{'background': 'rgba(18, 29, 45, 0.5)' }]]),
                          onClick: function ($event) { return ($setup.delete_element(question.response,index4)); }
                        }, [
                          createElementVNode("div", _hoisted_13, toDisplayString(listResponse), 1 /* TEXT */),
                          _hoisted_14
                        ], 12 /* STYLE, PROPS */, _hoisted_12)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 10 /* CLASS, PROPS */, _hoisted_11),
                  createCommentVNode(" <div style=\"display: flex;width:100%;cursor: pointer;margin-top:10px;margin-bottom:10px\" @click=\"delete_element(question.response,index6)\"> \n                                <div style=\"width:90%;\">{{document.name}}</div> \n                                <div style=\"width:10%;text-align: right;\"><strong>X</strong></div>\n                            </div> ")
                ], 10 /* CLASS, PROPS */, _hoisted_9))
              : createCommentVNode("v-if", true),
            (question.question_type=='toggle')
              ? (openBlock(), createElementBlock("div", {
                  key: 4,
                  id: 'content_toggle_'+index,
                  class: normalizeClass('content_textarea_'+index)
                }, [
                  ($setup.showPlasceholder==true)
                    ? (openBlock(), createElementBlock("label", {
                        key: 0,
                        for: question.testing_question_id+'_'+index
                      }, toDisplayString(question.question), 9 /* TEXT, PROPS */, _hoisted_16))
                    : createCommentVNode("v-if", true),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(question.options, function (option, index5) {
                    return (openBlock(), createElementBlock("button", {
                      key: option.testing_question_id,
                      class: normalizeClass([option.isActive == true ? option.activeClass+' ' + $setup.classInputs : $setup.classInputs]),
                      id: option.testing_question_id+'_'+index5,
                      name: option.testing_question_id+'_'+index5,
                      onClick: function ($event) { return ($setup.toggleActive(option, question.options, question)); }
                    }, toDisplayString(option.name_option), 11 /* TEXT, CLASS, PROPS */, _hoisted_17))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 10 /* CLASS, PROPS */, _hoisted_15))
              : createCommentVNode("v-if", true),
            (question.question_type=='checkbox')
              ? (openBlock(), createElementBlock("div", {
                  key: 5,
                  id: 'content_checkbox_'+index,
                  class: normalizeClass('content_checkbox_'+index)
                }, [
                  ($setup.showPlasceholder==true)
                    ? (openBlock(), createElementBlock("label", {
                        key: 0,
                        for: question.testing_question_id+'_'+index
                      }, toDisplayString(question.question), 9 /* TEXT, PROPS */, _hoisted_19))
                    : createCommentVNode("v-if", true),
                  (openBlock(true), createElementBlock(Fragment, null, renderList(question.options, function (option, index) {
                    return (openBlock(), createElementBlock("div", {
                      style: {"width":"150px","display":"flex","margin-top":"10px"},
                      key: option.id
                    }, [
                      withDirectives(createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": function ($event) { return ((question.options[index].value) = $event); },
                        name: option.text,
                        value: option.text,
                        id: option.testing_question_id,
                        onChange: function ($event) { return ($setup.getSelectedCheckbox(question.options, question)); },
                        style: {"width":"30px","height":"30px"},
                        class: "accent-cheked"
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_20), [
                        [vModelCheckbox, question.options[index].value]
                      ]),
                      createElementVNode("label", {
                        for: option.testing_question_id,
                        style: {"margin-left":"10px"}
                      }, toDisplayString(option.name_option), 9 /* TEXT, PROPS */, _hoisted_21)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 10 /* CLASS, PROPS */, _hoisted_18))
              : createCommentVNode("v-if", true),
            (question.question_type=='date')
              ? (openBlock(), createElementBlock("div", {
                  key: 6,
                  id: 'content_date_'+index,
                  class: normalizeClass('content_date_'+index)
                }, [
                  ($setup.showPlasceholder==true)
                    ? (openBlock(), createElementBlock("label", {
                        key: 0,
                        for: question.testing_question_id+'_'+index
                      }, toDisplayString(question.question), 9 /* TEXT, PROPS */, _hoisted_23))
                    : createCommentVNode("v-if", true),
                  createVNode(_component_DatePicker, {
                    modelValue: question.response,
                    "onUpdate:modelValue": function ($event) { return ((question.response) = $event); },
                    format: "DD/MM/YYYY",
                    simple: "",
                    locale: "es",
                    onChange: function ($event) { return (question.is_touched=true); },
                    localeConfig: {
                                    es: {
                                        displayFormat: 'DD/MM/YYYY',
                                        lang: {
                                            year: 'Año',
                                            month: 'Mes',
                                            day: 'Día',
                                            label: '',
                                            submit: 'Seleccionar',
                                            cancel: 'Cancelar',
                                            now: 'Hoy',
                                            nextMonth: 'Siguiente',
                                            prevMonth: 'Anterior',
                                        },
                                    }
                                }
                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onChange"])
                ], 10 /* CLASS, PROPS */, _hoisted_22))
              : createCommentVNode("v-if", true),
            (question.question_type=='file')
              ? (openBlock(), createElementBlock("div", {
                  key: 7,
                  id: 'content_file_'+index
                }, [
                  createCommentVNode(" <input :type=\"question.question_type\" :id=\"question.testing_question_id+'_'+index\" :name=\"question.testing_question_id+'_'+index\"\n                    :class=\"classInputs\" @blur=\"question.is_touched=true\" v-bind:style=\"selectStyle(question.errors.length,question.response)\" \n                    :placeholder=\"showPlasceholder==true?question.question:null\"  @change=\"loadDocument($event,question)\"> "),
                  ($setup.showPlasceholder==true)
                    ? (openBlock(), createElementBlock("label", {
                        key: 0,
                        for: question.testing_question_id+'_'+index
                      }, toDisplayString(question.question), 9 /* TEXT, PROPS */, _hoisted_25))
                    : createCommentVNode("v-if", true),
                  createElementVNode("div", {
                    class: normalizeClass($setup.classInputs),
                    onClick: function ($event) { return ($setup.getFile(question.testing_question_id+'_'+index)); },
                    onChange: function ($event) { return (question.is_touched=true); },
                    style: normalizeStyle($setup.selectStyle(question.errors.length,question.response))
                  }, [
                    createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      createElementVNode("div", _hoisted_29, [
                        createElementVNode("input", {
                          id: question.testing_question_id+'_'+index,
                          type: "file",
                          multiple: "",
                          accept: $props.documentsAllowed.join(','),
                          onChange: function ($event) { return ($setup.loadDocument($event,false,question)); }
                        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_30)
                      ])
                    ])
                  ], 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_26),
                  createElementVNode("div", {
                    style: {"margint-top":"10px","margint-bottom":"10px"},
                    class: normalizeClass($setup.classInputs)
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(question.response, function (document, index6) {
                      return (openBlock(), createElementBlock("div", { key: index6 }, [
                        createElementVNode("div", {
                          style: {"display":"flex","width":"100%","cursor":"pointer","margin-top":"10px","margin-bottom":"10px"},
                          onClick: function ($event) { return ($setup.delete_element(question.response,index6)); }
                        }, [
                          createElementVNode("div", _hoisted_32, toDisplayString(document.name), 1 /* TEXT */),
                          _hoisted_33
                        ], 8 /* PROPS */, _hoisted_31)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 2 /* CLASS */)
                ], 8 /* PROPS */, _hoisted_24))
              : createCommentVNode("v-if", true),
            createElementVNode("div", {
              class: normalizeClass($setup.classErrorsContainer)
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(question.errors, function (error, index2) {
                return (openBlock(), createElementBlock("div", { key: index2 }, [
                  createElementVNode("div", {
                    class: normalizeClass($setup.classErrorsText)
                  }, toDisplayString(error.$message), 3 /* TEXT, CLASS */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */)
          ]))
        : createCommentVNode("v-if", true)
    ], 2 /* CLASS */))
  }), 128 /* KEYED_FRAGMENT */))
}

script.render = render;
script.__file = "src/input-reactive-for-vue.vue";

// Import vue component

// Declare install function executed by Vue.use()
function install(Vue) {
	if (install.installed) { return; }
	install.installed = true;
	Vue.component('InputReactiveForm', script);
}

// Create module definition for Vue.use()
var plugin = {
	install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}

export { script as default, install };
